import { connect } from 'react-redux';

import TooltipContent from '@/components/StatisticsTooltipContent';
import {
  getDateBySelectedIndex,
  getPropBySelectedIndex,
  getScale,
} from '@/features/purchasesStatisticsPage/selectors';
import stats from '@/features/purchasesStatisticsPage/stats';
import { getStatsIds } from '@/features/statisticsPage/selectors';

const mapStateToProps = (state, { selectedDateIndex }) => ({
  date: getDateBySelectedIndex(state, selectedDateIndex),
  selectedStatsIds: getStatsIds(state),
  scale: getScale(state),
  getValue: getPropBySelectedIndex,
  stats,
});

export default connect(mapStateToProps)(TooltipContent);
